<template>
  <div style="padding: 20px">
    <el-card>
      <template #header>
        <div style="display:flex;justify-content:space-between;align-items:center">
          <span>成长雷达查看</span>
        </div>
      </template>

      <el-form :inline="true" @submit.prevent>
        <el-form-item label="师徒人员">
          <el-input v-model="keyword" placeholder="导师/徒弟姓名" clearable style="width:220px" @keyup.enter="load" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="load">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="list" border v-loading="loading" style="width:100%">
        <el-table-column label="导师" prop="mentorName" min-width="120" />
        <el-table-column label="徒弟" prop="apprenticeName" min-width="120" />
        <el-table-column label="期 / 阶段" width="160">
          <template #default="{row}">{{ periodStageText(row) }}</template>
        </el-table-column>
        <el-table-column prop="radar.assessmentPeriod" label="评估周期" width="140" />
        <el-table-column prop="radar.totalScore" label="总分" width="90" />
        <el-table-column label="健康" width="120">
          <template #default="{row}">
            <el-tag :type="healthTag(row.radar.healthType)">{{ healthText(row.radar.healthType) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="110" fixed="right">
          <template #default="{row}">
            <el-button size="small" type="primary" @click="openDetail(row)">查看雷达</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination style="margin-top:12px" background layout="total, sizes, prev, pager, next, jumper"
        :total="total" :current-page="query.page" :page-size="query.size" :page-sizes="[10, 20, 50, 100]"
        @current-change="onPage" @size-change="onSize" />
    </el-card>

    <el-dialog v-model="detailVisible" title="雷达详情" width="420px" append-to-body>
      <div v-loading="detailLoading" style="min-height:120px">
        <template v-if="detail">
          <el-descriptions title="最新评估" border size="small" style="margin-bottom:12px">
            <el-descriptions-item label="导师">{{ detailMentor }}</el-descriptions-item>
            <el-descriptions-item label="徒弟">{{ detailApprentice }}</el-descriptions-item>
            <el-descriptions-item label="期/阶段">{{ detailPeriodStage }}</el-descriptions-item>
            <el-descriptions-item label="周期">{{ latest.assessmentPeriod || '-' }}</el-descriptions-item>
            <el-descriptions-item label="总分">{{ latest.totalScore }}</el-descriptions-item>
            <el-descriptions-item label="健康类型">
              <el-tag :type="healthTag(latest.healthType)">{{ healthText(latest.healthType) }}</el-tag>
            </el-descriptions-item>
          </el-descriptions>

          <div class="radar-wrap">
            <svg viewBox="0 0 240 240" width="260" height="260">
              <polygon :points="grid(1)" class="grid" />
              <polygon :points="grid(0.66)" class="grid" />
              <polygon :points="grid(0.33)" class="grid" />
              <line v-for="(p,i) in axis" :key="'a'+i" :x1="cx" :y1="cy" :x2="p.x" :y2="p.y" class="axis" />
              <text v-for="(p,i) in axis" :key="'t'+i" :x="p.tx" :y="p.ty" class="axis-label">{{ axes[i] }}</text>
              <polygon :points="valuePoints" class="val" />
            </svg>
          </div>

          <el-table :data="detail" border size="small" style="margin-top:12px">
            <el-table-column prop="assessmentPeriod" label="周期" />
            <el-table-column prop="learningScore" label="学习成长" />
            <el-table-column prop="influenceScore" label="影响力" />
            <el-table-column prop="funScore" label="乐趣" />
            <el-table-column prop="rewardScore" label="回报" />
            <el-table-column prop="totalScore" label="总分" />
            <el-table-column label="健康">
              <template #default="{row}"><el-tag :type="healthTag(row.healthType)" size="small">{{ healthText(row.healthType) }}</el-tag></template>
            </el-table-column>
          </el-table>
        </template>
        <el-empty v-else description="暂无雷达数据" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mentorRadarPage, mentorRadar } from '@/api/mentor'
import { ElMessage } from 'element-plus'

export default {
  name: 'MentorRadarView',
  data () {
    return {
      keyword: '',
      loading: false,
      list: [],
      total: 0,
      query: { page: 1, size: 10, keyword: '' },
      axes: ['学习成长', '影响力', '乐趣', '回报'],
      cx: 120, cy: 120, r: 86,
      // 详情
      detailVisible: false, detailLoading: false, detail: null,
      detailMentor: '', detailApprentice: '', detailPeriodStage: '', detailRelationId: null
    }
  },
  computed: {
    latest () { return (this.detail && this.detail[0]) || null },
    axis () {
      const pts = []
      for (let i = 0; i < 4; i++) {
        const ang = -Math.PI / 2 + i * Math.PI / 2
        pts.push({ x: this.cx + this.r * Math.cos(ang), y: this.cy + this.r * Math.sin(ang),
                   tx: this.cx + (this.r + 14) * Math.cos(ang), ty: this.cy + (this.r + 14) * Math.sin(ang) + 4 })
      }
      return pts
    },
    valuePoints () {
      const s = this.latest ? [this.latest.learningScore, this.latest.influenceScore, this.latest.funScore, this.latest.rewardScore] : [0,0,0,0]
      return s.map((v, i) => {
        const ang = -Math.PI / 2 + i * Math.PI / 2
        const val = Math.min(Number(v || 0), 10) / 10
        return (this.cx + this.r * val * Math.cos(ang)) + ',' + (this.cy + this.r * val * Math.sin(ang))
      }).join(' ')
    }
  },
  mounted () {
    this.load()
    // 从「师徒关系管理」深链进入：直接打开指定 relationId 的雷达详情
    const q = this.$route.query
    if (q.relationId) {
      this.openRadarDetail({
        relationId: q.relationId,
        mentorName: q.mentorName || '',
        apprenticeName: q.apprenticeName || '',
        periodStage: q.periodStage || ''
      })
    }
  },
  methods: {
    async load () {
      this.loading = true
      const params = { page: this.query.page, size: this.query.size }
      if (this.keyword) params.keyword = this.keyword.trim()
      const r = await mentorRadarPage(params)
      this.loading = false
      if (r && r.code === 200 && r.data) {
        this.list = r.data.records || []
        this.total = r.data.total || 0
      } else {
        this.list = []
        this.total = 0
        if (r) ElMessage.warning(r.message || '查询失败')
      }
    },
    reset () { this.keyword = ''; this.query.page = 1; this.load() },
    onPage (p) { this.query.page = p; this.load() },
    onSize (s) { this.query.size = s; this.query.page = 1; this.load() },
    periodStageText (row) {
      const period = row.period
      const stage = row.stageMonth
      if (!period) return this.stageLabel(stage)
      return period + '期·' + this.stageLabel(stage)
    },
    stageLabel (s) { if (!s || s <= 0) return '-'; if (s > 12) return '已满期(' + s + '个月)'; return '第' + s + '个月' },
    healthText (t) { return t === 2 ? '全面预警' : t === 1 ? '结构性失衡' : '全面健康' },
    healthTag (t) { return t === 2 ? 'danger' : t === 1 ? 'warning' : 'success' },
    async openDetail (row) {
      const relationId = row.radar && row.radar.relationId
      await this.openRadarDetail({
        relationId,
        mentorName: row.mentorName || '',
        apprenticeName: row.apprenticeName || '',
        periodStage: this.periodStageText(row)
      })
    },
    async openRadarDetail ({ relationId, mentorName, apprenticeName, periodStage }) {
      this.detailVisible = true
      this.detailLoading = true
      this.detail = null
      this.detailMentor = mentorName
      this.detailApprentice = apprenticeName
      this.detailPeriodStage = periodStage || ''
      const r = await mentorRadar({ relationId: Number(relationId) })
      this.detailLoading = false
      if (r && r.code === 200) this.detail = r.data || []
      else ElMessage.warning((r && r.message) || '加载失败')
    },
    grid (scale) {
      const pts = []
      for (let i = 0; i < 4; i++) {
        const ang = -Math.PI / 2 + i * Math.PI / 2
        pts.push((this.cx + this.r * scale * Math.cos(ang)) + ',' + (this.cy + this.r * scale * Math.sin(ang)))
      }
      return pts.join(' ')
    }
  }
}
</script>

<style scoped>
.radar-wrap { display: flex; justify-content: center; padding: 12px 0; }
.grid { fill: none; stroke: #eee; }
.axis { stroke: #ddd; }
.axis-label { font-size: 11px; fill: #666; text-anchor: middle; }
.val { fill: rgba(64,158,255,0.25); stroke: #409eff; stroke-width: 2; }

/* 清爽简约风 */
:deep(.el-card) { border-radius: 12px; box-shadow: 0 2px 8px rgba(31, 45, 61, .08); }
:deep(.el-card__header) { font-weight: 600; background: #fafbfc; border-radius: 12px 12px 0 0; }
:deep(.el-button) { border-radius: 6px; }
</style>
